import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { selectIsMobileView } from 'store/common/mobileView/selectors';
import { isScreenBelow640, isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import { REQUEST_ERROR } from 'store/constants';
import {
  getCatalogFiltersAvailability,
  getFilterBrandsAvailability,
} from 'store/ProductCatalog/filters/selectors';
import {
  getCatalogPaginationAvailability,
  getCatalogProductsNotEmpty,
  getCatalogProductsRequestStatus,
  selectCatalogShowMoreLoading,
} from 'store/ProductCatalog/products/selectors';
import {
  getCatalogIsTariffCollectionFlag,
  getTagsListAvailability,
} from 'store/ProductCatalog/selectors';
import commonStyles from 'styles/common.pcss';

import CatalogViewLayout from '../_CatalogViewLayout';
import {
  BrandsWidget,
  PaginationWidget,
  ProductCollectionWidget,
  PromoBanner,
  TagsWidget,
  ViewFilters,
  WarningMessageWidget,
} from '../../components';
import { contentContainerId } from '../../constants';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

/**
 * Covers Main catalog view as well as Search View
 */
class MainViewLayout extends Component {
  /**
   * each element returned in the array, is wrapped with a ContentLiner,
   * to prevent this behavior: pass multiple elements wrapped into React.Fragment or any other component
   */
  renderBottomChildren() {
    const { filtersAvailability, hasBrands, hasTags, isMobileView } = this.props;
    if (isMobileView) {
      return [];
    }
    return [
      hasBrands && filtersAvailability && <BrandsWidget className={cx('marb-xs')} key="brand" />,
      hasTags && <TagsWidget className={cx('marb-xs')} crop={5} key="tags" />,
    ];
  }

  render() {
    const {
      filtersAvailability,
      hasErrors,
      hasPagination,
      isMobile,
      isShowMoreLoading,
      isTablet,
      isTariffsCollection,
    } = this.props;
    return (
      <CatalogViewLayout
        bottomChildren={this.renderBottomChildren()}
        /** container id is used for scrolling up on no-sidebar layouts */
        id={contentContainerId}
        isSimpleView={isTariffsCollection}
      >
        <div className={cx({ 'padh-s': isMobile })}>
          <ViewFilters
            isMobile={isMobile}
            showButton={isTablet && !isTariffsCollection && filtersAvailability}
          />
          {hasErrors && <WarningMessageWidget className={cx('marb-s')} />}
          {!hasErrors && <PromoBanner />}
          <ProductCollectionWidget>
            <div
              className={cx('pagination', 'padt-s', 'padb-m', {
                disabled: isShowMoreLoading,
                hidden: !hasPagination,
              })}
            >
              <PaginationWidget />
            </div>
          </ProductCollectionWidget>
        </div>
      </CatalogViewLayout>
    );
  }
}

MainViewLayout.propTypes = {
  filtersAvailability: PropTypes.bool,
  hasBrands: PropTypes.bool,
  hasErrors: PropTypes.bool,
  /** availability props */
  hasPagination: PropTypes.bool,
  hasTags: PropTypes.bool,

  /** display type props */
  isMobile: PropTypes.bool,
  isMobileView: PropTypes.bool,
  isShowMoreLoading: PropTypes.bool,
  isTablet: PropTypes.bool,
  isTariffsCollection: PropTypes.bool,

  /**
   * NOTE: DO NOT ADD PROPS HERE,
   * unless they relate to one of the groups"
   * display type / availability
   */
};

const mapStateToProps = (state) => ({
  filtersAvailability: getCatalogFiltersAvailability(state),
  hasBrands: getFilterBrandsAvailability(state),
  hasErrors:
    getCatalogProductsRequestStatus(state) === REQUEST_ERROR || !getCatalogProductsNotEmpty(state),
  hasPagination: getCatalogPaginationAvailability(state),
  hasTags: getTagsListAvailability(state),
  isMobile: isScreenBelow640(state),
  isMobileView: selectIsMobileView(state),
  isShowMoreLoading: selectCatalogShowMoreLoading(state),
  isTablet: isScreenBelow1004(state),
  isTariffsCollection: getCatalogIsTariffCollectionFlag(state),
});

const MainView = connect(mapStateToProps)(MainViewLayout);

/** own props for connected component */
MainView.propTypes = {
  isSearchPage: PropTypes.bool,
};

export default MainView;
